import { Flex, Box, Text, Link, Avatar } from '@chakra-ui/react';
// import { format } from 'date-fns';
import { Link as RouterLink } from 'react-router-dom';
import { PhoneIcon, EmailIcon, CarIcon, HomeIcon } from 'components/Icons';
import { useAuthContext } from 'context/AuthProvider';
import { formatPhoneNumber } from 'utils';

const ProfileDetails = ({ full }: ProfileDetailsProps): JSX.Element => {
  const { user, userData } = useAuthContext();
  return (
    <Flex direction="column" width="100%" mt={full ? 0 : 10}>
      <Flex
        ml="114px"
        direction="row"
        justifyContent="space-between"
        px={4}
        py={2}
      >
        <Text fontSize="20px" fontWeight="bold" color="#212121">
          {`
            ${full ? '' : 'Hi, '}
            ${userData?.firstname || ''}
            ${full ? userData?.lastname || '' : ''}
            `.trim()}
        </Text>
        <Link
          as={RouterLink}
          to="/edit-profile"
          fontWeight="bold"
          color="#259BE9"
        >
          Edit
        </Link>
      </Flex>
      <Flex
        bg="#DFF0FC"
        width="100%"
        direction="column"
        flexGrow={full ? 1 : undefined}
      >
        <Flex direction="row">
          <Avatar
            size="xl"
            name="Profile picture"
            src={user?.photoURL || ''}
            top="-48px"
            left="18px"
            border="2px solid #FFFFFF"
          />
          {/* <Flex ml="18px" px={4} maxHeight="48px">
            <Flex height="fit-content" alignItems="center">
              {`${userData?.birthday?.seconds ? format((userData?.birthday?.seconds * 1000), 'MM/dd/yyyy') : ''}`}
              <span
                style={{
                  height: "4px",
                  width: "4px",
                  backgroundColor: "#666",
                  borderRadius: "50%",
                  display: "inline-block",
                  marginLeft: "5px",
                  marginRight: "5px"
                }}
              />
              {`${userData?.gender}`}
            </Flex>
          </Flex> */}
        </Flex>
        <Flex
          direction="column"
          bg="#FFFFFF"
          borderRadius="8px"
          mx={3}
          mb={10}
          mt={-8}
          p={3}
          justifyContent="space-between"
        >
          <Flex direction="row" mb={4}>
            <Box width="30px">
              <PhoneIcon />
            </Box>
            <Text ml={3}>{formatPhoneNumber(userData?.phoneNumber)}</Text>
          </Flex>
          <Flex direction="row" mb={4}>
            <Box width="30px">
              <EmailIcon />
            </Box>
            <Text ml={3}>{user?.email}</Text>
          </Flex>
          <Flex direction="row" alignItems="center" mb={4}>
            <Box width="30px">
              <CarIcon />
            </Box>
            <Flex direction="column" ml={3}>
              <Text>{`Has${userData?.hasCar ? ' ' : ' no '}car`}</Text>
              <Text>
                {userData?.commuteTime &&
                  `Willing to travel up to ${userData?.commuteTime} min.`}
              </Text>
            </Flex>
          </Flex>
          {full && (
            <Flex direction="row" alignItems="center">
              <Box width="30px">
                <HomeIcon fill="black" />
              </Box>
              <Flex direction="column" ml={3}>
                <Text>{userData?.address?.streetAddress || ''}</Text>
                <Text>
                  {`${userData?.address?.city || ''}, ${
                    userData?.address?.state || ''
                  } ${userData?.address?.zipCode || ''}`}
                </Text>
              </Flex>
            </Flex>
          )}
        </Flex>
        {!full && (
          <Flex direction="row" justifyContent="center" mt={-6} mb={6}>
            <Link
              as={RouterLink}
              to="/profile"
              fontWeight="bold"
              color="#0F6299"
            >
              View full profile
            </Link>
          </Flex>
        )}
      </Flex>
    </Flex>
  );
};

export default ProfileDetails;
